import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CommentViewerComponent } from './comment-viewer.component';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatDateModule } from '@go-modules/pipes/format-date/format-date.module';
import { MarkerDisplayModule } from '@go-modules/components/marker-display/marker-display.module';
import { CommentMenuModule } from '@go-modules/components/feedback-session/comment-menu/comment-menu.module';
import { MediaPreviewDirective } from '@go-modules/angularjs-wrappers/media-preview.directive';
import { CommentReactionsModule } from '@go-modules/components/feedback-session/comment-reactions/comment-reactions.module';
import { FeedbackCreatorModule } from '@go-modules/components/feedback-session/feedback-creator/feedback-creator.module';
import { FeedbackTimeEditorModule } from '@go-modules/components/feedback-session/feedback-time-editor/feedback-time-editor.module';
import { SanitizePipeModule } from '@go-modules/pipes/sanitize/sanitize.pipe.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TrackByPropPipeModule } from '@go-modules/pipes/track-by-prop/track-by-prop-pipe.module';
import { TimeUtils } from '@go-modules/utilities/time/time-utils';
import { CollectionDestinationModule } from '@go-modules/components/library/collection-destination/collection-destination.module';
@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormatTimeModule,
		GoMaterialModule,
		FormatDateModule,
		MarkerDisplayModule,
		CommentReactionsModule,
		CommentMenuModule,
		FeedbackCreatorModule,
		FeedbackTimeEditorModule,
		SanitizePipeModule,
		ScrollingModule,
		TrackByPropPipeModule,
		CollectionDestinationModule
	],
	exports: [
		CommentViewerComponent
	],
	declarations: [
		CommentViewerComponent,
		MediaPreviewDirective
	],
	providers: [TimeUtils]
})
export class CommentViewerModule {}
